<template>
<BootstrapDialog title="修改子机构" ref="dialog" size="lg" @afterClose="afterClose()">
		<template v-slot:body>
			<div class="modal-body wrapper-lg" style="width:100%">
			    <div class="row">
			        <div class="col-sm-8 col-sm-offset-2">
			            <form role="form">
			                <div class="form-group">
			                    <label><span style="color: red">*</span>子机构代码</label>
			                    <input type="text" name="zjgdm" v-model="model.jgdm" v-validate="'required'" data-vv-as="子机构代码" class="form-control" placeholder=""/>
			                    <span class="error_validate_msg"><em>{{ errors.first('zjgdm') }}</em></span>
			                </div>
			                <div class="form-group">
			                    <label><span style="color: red">*</span>子机构名称</label>
			                    <input type="text" name="zjgmc" v-model="model.jgmc" v-validate="'required'" data-vv-as="子机构名称" class="form-control" placeholder=""/>
			                    <span class="error_validate_msg"><em>{{ errors.first('zjgmc') }}</em></span>
			                </div>
			            </form>
			        </div>
			    </div>
			</div>
		</template>
		<template v-slot:footer>
				<button class="btn btn-primary" type="button" @click="save()">保存</button>
				<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
		</template>
</BootstrapDialog>
</template>
<script>
    export default {
        name:'ChildOrgEdit',
		components:{
		},
        data:function(){
            return {
                model:{
                    id:'',
                    jgdm:'',
                    jgmc:''
                }
            }
        },
        methods:{
			reset:function(){
				this.model = {
					id:'',
					jgdm:'',
					jgmc:''
				}
			},
			async open(params){
				this.model.id = params.id;
				let res =await this.$http.post('/htgl/sys/zjg/hq',{id:this.model.id});
				if(res.data){
					 this.model = res.data;
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/sys/zjg/xg',this.model).then(res=>{
                            if(res.data==true){
								this.$success('操作成功',()=>{
										this.close();
										this.$parent.load();//刷新列表
								});
                            }
                        });
                    }
                });
            }
        }
    }
</script>